import { ChapterEnum, OtherCostCalculationTypeEnum, ProjectMethodologyEnum, SectionEnum } from 'gql/graphql';

/*
Способ создания прочих.
 */
export const enum CreatingTypes {
    /*
    Вручную
     */
    MANUAL = 'MANUAL',
    /*
    Из справочника методик расчёта
     */
    BOOK = 'BOOK',
}

export const enum TabsIds {
    COMMON = 'COMMON',
    PRICE = 'PRICE',
    FORMULA = 'FORMULA',
}

export type TabItem = {
    id: TabsIds;
    label: string;
};

export type TypeItem = {
    id: OtherCostCalculationTypeEnum;
    label: string;
};

export const TYPE_VARIANTS: TypeItem[] = [
    {
        id: OtherCostCalculationTypeEnum.Calculation,
        label: 'Расчет',
    },
    {
        id: OtherCostCalculationTypeEnum.Percent,
        label: '%',
    },
];

export const tabsItems = [
    { id: TabsIds.COMMON, label: 'Общие данные' },
    { id: TabsIds.PRICE, label: 'Лимиты по договору' },
    { id: TabsIds.FORMULA, label: 'Формула' },
];

export const getTabItemsByMethodology = (methodology: ProjectMethodologyEnum) => {
    if (methodology === ProjectMethodologyEnum.Uer) {
        return tabsItems.filter((_, i) => i < 2);
    }

    return tabsItems;
};

export enum SeasonItemsIdsEnum {
    LAST_SEASON = 'LAST_SEASON',
    FIRST_SEASON = 'FIRST_SEASON',
    EVENLY_BY_SEASON = 'EVENLY_BY_SEASON',
    FILE = 'FILE',
    MANUAL = 'MANUAL',
    AUTO = 'AUTO',
}

const readOnlySeasonItem = { label: 'Из файла', id: SeasonItemsIdsEnum.FILE };

export const seasonItems = [
    { label: 'Последний сезон', id: SeasonItemsIdsEnum.LAST_SEASON },
    { label: 'Первый сезон', id: SeasonItemsIdsEnum.FIRST_SEASON },
    { label: 'Равномерно', id: SeasonItemsIdsEnum.EVENLY_BY_SEASON },
    { label: 'Вручную', id: SeasonItemsIdsEnum.MANUAL },
    { label: 'Автоматически', id: SeasonItemsIdsEnum.AUTO },
];

export const availableChapters: Record<string, string> = {
    CHAPTER1_7: 'Глава 1-7',
    CHAPTER8: 'Глава 8',
    CHAPTER9: 'Глава 9',
};

export const availableTypes: Record<string, string> = {
    CALCULATION: 'Расчет',
    PERCENT: 'Процент',
};

export const seasonByDistributionMethod: Record<string, Record<string, string>> = {
    LAST_SEASON: seasonItems[0],
    FIRST_SEASON: seasonItems[1],
    EVENLY_BY_SEASON: seasonItems[2],
    FILE: readOnlySeasonItem,
    MANUAL: seasonItems[3],
    AUTO: seasonItems[4],
};

export const OTHER_SECTION_OR_CHAPTER = [
    {
        id: ChapterEnum.Chapter9,
        label: availableChapters[ChapterEnum.Chapter9],
    },
    {
        id: SectionEnum.CustomerLimits,
        label: 'Лимиты Заказчика',
    },
];
